import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "guide-page"
};
const _hoisted_2 = {
  class: "header-content admin-header-content"
};
const _hoisted_3 = {
  class: "header-action"
};
const _hoisted_4 = {
  class: "guide-content"
};
const _hoisted_5 = {
  class: "guide-intro"
};
const _hoisted_6 = {
  class: "provider-heading"
};
const _hoisted_7 = {
  class: "provider-links"
};
const _hoisted_8 = {
  class: "guide-table-wrap"
};
const _hoisted_9 = {
  class: "guide-table"
};
const _hoisted_10 = {
  scope: "row"
};
const _hoisted_11 = {
  class: "guide-notes"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DashboardTabs = _resolveComponent("DashboardTabs");
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_alert = _resolveComponent("el-alert");
  const _component_el_link = _resolveComponent("el-link");
  const _component_el_image = _resolveComponent("el-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_header, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_DashboardTabs, {
      activeTab: "systemConfig"
    }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
      text: "",
      class: "back-button",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/systemConfig#upload'))
    }, {
      default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
        icon: "arrow-left"
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('webUploaderGuide.backToChannels')), 1)]),
      _: 1
    })])])]),
    _: 1
  }), _createElementVNode("main", _hoisted_4, [_createElementVNode("section", _hoisted_5, [_createElementVNode("div", null, [_cache[1] || (_cache[1] = _createElementVNode("p", {
    class: "guide-eyebrow"
  }, "Web Uploader", -1)), _createElementVNode("h1", null, _toDisplayString(_ctx.$t('webUploaderGuide.title')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('webUploaderGuide.intro')), 1)]), _createVNode(_component_el_alert, {
    title: _ctx.$t('webUploaderGuide.securityTitle'),
    description: _ctx.$t('webUploaderGuide.securityDescription'),
    type: "warning",
    closable: false,
    "show-icon": ""
  }, null, 8, ["title", "description"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.guides, guide => {
    return _openBlock(), _createElementBlock("section", {
      key: guide.id,
      class: "provider-guide"
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createElementVNode("h2", null, _toDisplayString(_ctx.$t(guide.titleKey)), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t(guide.summaryKey)), 1)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_link, {
      href: guide.documentationUrl,
      target: "_blank",
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('webUploaderGuide.uploadDocumentation')) + " ", 1), _createVNode(_component_font_awesome_icon, {
        icon: "external-link-alt"
      })]),
      _: 1
    }, 8, ["href"]), guide.deleteDocumentationUrl ? (_openBlock(), _createBlock(_component_el_link, {
      key: 0,
      href: guide.deleteDocumentationUrl,
      target: "_blank",
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('webUploaderGuide.deleteDocumentation')) + " ", 1), _createVNode(_component_font_awesome_icon, {
        icon: "external-link-alt"
      })]),
      _: 1
    }, 8, ["href"])) : _createCommentVNode("", true)])]), guide.image ? (_openBlock(), _createBlock(_component_el_image, {
      key: 0,
      src: guide.image,
      "preview-src-list": [guide.image],
      fit: "contain",
      class: "guide-image"
    }, null, 8, ["src", "preview-src-list"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, _toDisplayString(_ctx.$t('webUploaderGuide.table.field')), 1), _createElementVNode("th", null, _toDisplayString(_ctx.$t('webUploaderGuide.table.value')), 1)])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guide.fields, field => {
      return _openBlock(), _createElementBlock("tr", {
        key: field.labelKey
      }, [_createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t(field.labelKey)), 1), _createElementVNode("td", null, [_createElementVNode("pre", null, _toDisplayString(field.valueKey ? _ctx.$t(field.valueKey) : field.value), 1)])]);
    }), 128))])])]), _createElementVNode("ul", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guide.notes, note => {
      return _openBlock(), _createElementBlock("li", {
        key: note
      }, _toDisplayString(_ctx.$t(note)), 1);
    }), 128))])]);
  }), 128))])]);
}